import React, { useState, useEffect } from 'react';
import '../../styles/csrEmailTable.css';
import SubLinks from '../../components/header/SubLinks.jsx';
import { scLinks } from '../../config/standard-links.js';
import useNewScs from '../../hooks/useNewScs.js';

const ScDashboard = () => {
    const [activeTab, setActiveTab] = useState('activity');

    return (
        <div className="notes-container">
            <SubLinks links={scLinks} />
            <br />
            <br />
            <br />
            <div className="sc-dashboard">
                {/* Dashboard Header */}
                <div className="dashboard-header">
                    <h1>SC Dashboard</h1>
                </div>

                {/* Tabs Navigation */}
                <div className="dashboard-tabs">
                    <button
                        className={activeTab === 'activity' ? 'active' : ''}
                        onClick={() => setActiveTab('activity')}>
                        Activity Logs
                    </button>

                    <button
                        className={activeTab === 'progress' ? 'active' : ''}
                        onClick={() => setActiveTab('progress')}>
                        Module Progress
                    </button>
                </div>

                {/* Tab Content */}
                <div className="tab-content">
                    {activeTab === 'activity' && <ActivityLogsTable />}
                    {activeTab === 'progress' && <ProgressTable />}
                </div>
            </div>
        </div>
    );
};

// Table Components
const ActivityLogsTable = () => {
    const {
        logs,
        loading,
        error,
        totalPages,
        filters,
        setFilters,
        searchName,
        setSearchName,
        triggerFetchLogs
    } = useNewScs();

    // Fetch logs on page or filter changes
    useEffect(() => {
        triggerFetchLogs();
    }, [filters]);

    return (
        <div className="email-log-container">
            <h2>Activity Logs</h2>
            {/* Filter Inputs */}
            <div
                className="filters"
                style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                <div className="filter-group">
                    <label htmlFor="scSearch">SC Name</label>
                    <input
                        id="scSearch"
                        type="text"
                        placeholder="Search SC Name..."
                        value={searchName}
                        onChange={(e) => setSearchName(e.target.value)}
                    />
                </div>
                {/* <select
                    value={filters.action || ''}
                    onChange={(e) =>
                        setFilters((prev) => ({
                            ...prev,
                            action: e.target.value,
                            page: 1
                        }))
                    }>
                    <option value="">All Actions</option>
                    <option value="created">Created</option>
                    <option value="updated">Updated</option>
                    <option value="deleted">Deleted</option>
                </select> */}
                <div className="filter-group">
                    <label htmlFor="startDate">Start Date</label>
                    <input
                        id="startDate"
                        type="date"
                        value={filters.startDate || ''}
                        onChange={(e) =>
                            setFilters((prev) => ({
                                ...prev,
                                startDate: e.target.value,
                                page: 1
                            }))
                        }
                    />
                </div>
                <div className="filter-group">
                    <label htmlFor="endDate">End Date</label>
                    <input
                        id="endDate"
                        type="date"
                        value={filters.endDate || ''}
                        onChange={(e) =>
                            setFilters((prev) => ({
                                ...prev,
                                endDate: e.target.value,
                                page: 1
                            }))
                        }
                    />
                </div>
            </div>
            {loading && <p>Loading...</p>}
            {error && <p className="error-text">{error}</p>}

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>New SC Name</th>
                            <th>SC Email</th>
                            <th>Action</th>
                            <th>Performed By</th>
                            <th>Performer Email</th>
                            <th>Role</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs.length > 0
                            ? logs.map((log, idx) => (
                                  <tr key={idx}>
                                      <td>{log.scName}</td>
                                      <td>{log.scEmail}</td>
                                      <td>{log.action}</td>
                                      <td>{log.adminName}</td>
                                      <td>{log.adminEmail}</td>
                                      <td>{log.role}</td>
                                      <td>
                                          {new Date(
                                              log.date
                                          ).toLocaleDateString()}
                                      </td>
                                  </tr>
                              ))
                            : !loading && (
                                  <tr>
                                      <td colSpan="7">No logs found</td>
                                  </tr>
                              )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination" style={{ marginTop: '2rem' }}>
                <button
                    onClick={() =>
                        setFilters((prev) => ({ ...prev, page: prev.page - 1 }))
                    }
                    disabled={filters.page === 1}>
                    Prev
                </button>
                <span>
                    Page {filters.page} of {totalPages}
                </span>
                <button
                    onClick={() =>
                        setFilters((prev) => ({ ...prev, page: prev.page + 1 }))
                    }
                    disabled={filters.page === totalPages}>
                    Next
                </button>
            </div>
        </div>
    );
};

const ProgressTable = () => {
    const [searchValue, setSearchValue] = useState('');
    const {
        getScCheckpointResults,
        loadingCheckpoint,
        checkpointError,
        checkpointResults
    } = useNewScs();

    const handleSearch = async () => {
        if (!searchValue) return;

        await getScCheckpointResults(searchValue);
    };

    return (
        <div className="email-log-container">
            <h2>Module Progress</h2>

            {/* Search Filter */}
            <div
                className="filters"
                style={{
                    display: 'flex',
                    width: '50%',
                    alignItems: 'center',
                    gap: '1rem',
                    marginBottom: '1rem'
                }}>
                <div className="filter-group">
                    <label htmlFor="scSearch">SC Email</label>
                    <input
                        id="scSearch"
                        type="text"
                        placeholder="Enter SC email..."
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                </div>
                <button
                    className="csr-fetch-button"
                    style={{
                        padding: '.5em 1em',
                        height: '2.5em',
                        marginTop: '1.2em'
                    }}
                    onClick={handleSearch}>
                    Search
                </button>
            </div>

            {/* Loading / Error */}
            {loadingCheckpoint && <p>Loading checkpoint results...</p>}
            {!loadingCheckpoint && checkpointError && (
                <p className="error-text">{checkpointError.message}</p>
            )}

            {/* Table */}
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Module</th>
                            <th>Score</th>
                            <th>Timestamp</th>
                        </tr>
                    </thead>
                    <tbody>
                        {checkpointResults &&
                        checkpointResults.modules.length > 0
                            ? checkpointResults.modules.map((mod, idx) => (
                                  <tr key={idx}>
                                      <td>{mod.module}</td>
                                      <td>{mod.score || 'N/A'}</td>
                                      <td>{mod.timestamp || '—'}</td>
                                  </tr>
                              ))
                            : !loadingCheckpoint && (
                                  <tr>
                                      <td colSpan="3">
                                          No checkpoint results found.
                                      </td>
                                  </tr>
                              )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ScDashboard;
